import { SxProps, Theme } from '@mui/material';

export const styles: Record<'transaction' | 'counterparty' | 'upcomingPaymentItem', SxProps<Theme>> = {
  counterparty: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  transaction: {
    '& + &': {
      borderTop: (theme) => `1px solid ${theme.palette.gray[200]}`,
    },
    '&:hover': (theme) => ({
      backgroundColor: theme.palette.gray[100],
      color: theme.palette.gray[900],
      cursor: 'pointer',
    }),
    padding: (theme) => theme.spacing(2),
  },
  upcomingPaymentItem: {
    '& svg': {
      color: (theme) => theme.palette.gray['600'],
    },
  },
};
